export interface IReceivedCheckTotalSummary {
  checkCount: number
  totalCheckAmount: number
  totalCheckAppliedFunds: number
  totalRefundedFunds: number
}
export class ReceivedCheckTotalSummary {
  public checkCount: number
  public totalCheckAmount: number
  public totalCheckAppliedFunds: number
  public totalRefundedFunds: number
}
